import { render, staticRenderFns } from "./DiseaseList.vue?vue&type=template&id=f4a951a2&scoped=true&"
import script from "./DiseaseList.vue?vue&type=script&lang=js&"
export * from "./DiseaseList.vue?vue&type=script&lang=js&"
import style0 from "./DiseaseList.vue?vue&type=style&index=0&id=f4a951a2&lang=scss&scoped=true&"
import style1 from "./DiseaseList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a951a2",
  null
  
)

export default component.exports